/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React, { SVGProps } from 'react'

import { Box, Typography } from '@mui/material'
import parseISO from 'date-fns/parseISO'

export interface UserFieldProps {
  name: string
  icon?: React.ReactElement
  deadline?: string | undefined
  maxWidth?: number
  color?: string
}

const DeadlineIcon = ({ ...rest }: SVGProps<any>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 14.6668C10.7449 14.6668 12.9999 12.4916 12.9999 9.69953C12.9999 9.0141 12.9651 8.27933 12.5852 7.13736C12.2052 5.99543 12.1287 5.84803 11.727 5.1428C11.5553 6.58196 10.637 7.18176 10.4037 7.36103C10.4037 7.17453 9.84817 5.11213 9.00587 3.87813C8.179 2.66683 7.05447 1.87214 6.3951 1.3335C6.3951 2.35675 6.1073 3.87813 5.69513 4.6533C5.28297 5.42846 5.20557 5.4567 4.69073 6.03356C4.17593 6.61043 3.93963 6.7886 3.50913 7.48853C3.07865 8.1885 3 9.12076 3 9.8062C3 12.5982 5.2551 14.6668 8 14.6668Z"
      stroke-linejoin="round"
    />
  </svg>
)

export function UserField({
  name,
  icon,
  maxWidth,
  color = 'primary',
  deadline,
}: UserFieldProps) {
  const deadlineStatus = deadline
    ? parseISO(deadline) >= new Date()
      ? 'ongoing'
      : 'expired'
    : undefined

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        transition: 'background-color 200ms',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: 'grey.50',
        },
        height: '32px',
        maxWidth: maxWidth,
        pr: 1,
      }}
    >
      {icon && (
        <Box flexShrink={0} minWidth="20px">
          {React.cloneElement(icon, { display: 'block' })}
        </Box>
      )}
      {deadlineStatus && (
        <DeadlineIcon
          stroke={deadlineStatus === 'ongoing' ? '#888888' : '#F20404'}
        />
      )}

      <Typography
        color={
          deadlineStatus
            ? deadlineStatus === 'expired'
              ? '#F20404'
              : color
            : color
        }
        pl="3px"
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {name}
      </Typography>
    </Box>
  )
}

export default UserField
